<template>
  <div>
    <div class="row" v-if="userData.permissions['view_settings'] == 1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="UpdateSettings">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <b-form-group label="Membership Fees">
                      <input v-model="membership_fee" type="number" class="form-control fw-bold text-primary" />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Share Amount">
                      <input v-model="share_amount" type="number" class="form-control fw-bold text-primary" />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Minimum Share">
                      <input v-model="min_share" type="number" class="form-control fw-bold text-primary" />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Maximum Shares">
                      <input v-model="max_share" type="number" class="form-control fw-bold text-primary" />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Loan Charges">
                      <select v-model="loan_charges" class="form-control fw-bold text-primary">
                        <option value="flat">Flat Charge</option>
                        <option value="percentage">Percentage</option>
                      </select>
                    </b-form-group>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <b-form-group label="Dividends to Share">
                      <input v-model="dividends" type="number" class="form-control fw-bold text-primary" />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Interests to Share">
                      <input v-model="interests" type="number" class="form-control fw-bold text-primary" />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <label>Print Transactions</label>
                    <select class="form-control fw-bold text-primary" v-model="print_trans">
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                  <div class="row form-group mb-2">
                    <div :class="{ 'col-md-6': security != 1, 'col-md-12': security == 1 }"><label>Security</label>
                      <select class="form-control fw-bold text-primary" v-model="security">
                        <option value="1">Collateral Security</option>
                        <option value="2">Guarantors</option>
                        <option value="3">Both</option>
                      </select>
                    </div>
                    <div class="col-md-6" v-if="security != 1">
                      <label for="">No. of Guarantors</label>
                      <select class="form-control fw-bold text-primary" v-model="number_of_guarantors">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                      </select>
                    </div>

                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Withdraw Charges">
                      <select v-model="withdraw_charges" class="form-control fw-bold text-primary">
                        <option value="flat">Flat Charge</option>
                        <option value="percentage">Percentage</option>
                      </select>
                    </b-form-group>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group mb-2">
                    <label>Currency</label>
                    <input class="form-control fw-bold text-primary" type="text" v-model="currency" readonly>
                  </div>
                  <div class="form-group mb-2">
                    <label>Allow Withdraws even with a Pending Loan</label>
                    <select class="form-control fw-bold text-primary" v-model="show_balance">
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                  <div class="form-group mb-2">
                    <label class="fw-bold">Loan Limit (Savings *)</label>
                    <input v-model="loanlimit" type="number" class="form-control fw-bold text-primary" />

                  </div>
                  <div class="form-group">
                    <b-form-group label="Combine Interest and Fine">
                      <select v-model="combine_interest_fine" class="form-control fw-bold text-primary">
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </b-form-group>
                  </div>
                </div>
                <b-button type="submit" class="btn w-100 mt-2" variant="primary"><i class="fas fa-check-circle"></i>
                  Update</b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View the Company Settings</span></center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import appConfig from "@/app.config";
import { countriesMethods, countriesComputed } from "@/state/helpers";

export default {
  page: {
    title: "Facility Profile",
    meta: [{ name: "description", content: appConfig.description }]
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      logo: '',
      membership_fee: 0,
      share_amount: 0,
      min_share: 0,
      max_share: 0,
      dividends: 0,
      interests: 0,
      show_balance: 0,
      print_trans: 0,
      currency: "",
      loanlimit: 0,
      security: '1',
      number_of_guarantors: '1',
      combine_interest_fine: 0,
      loan_charges: '',
      withdraw_charges: ''
    };
  },
  methods: {
    ...countriesMethods,
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = (url).slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    async UpdateSettings() {
      let formData = new FormData();
      formData.append("membership_fee", this.membership_fee);
      formData.append("share_amount", this.share_amount);
      formData.append("min_share", this.min_share);
      formData.append("max_share", this.max_share);
      formData.append("dividends", this.dividends);
      formData.append("interests", this.interests);
      formData.append("print_trans", this.print_trans);
      formData.append("show_balance", this.show_balance);
      formData.append("loanlimit", this.loanlimit);
      formData.append("security", this.security);
      formData.append('number_of_guarantors', this.number_of_guarantors);
      formData.append('combine_interest_fine', this.combine_interest_fine);
      formData.append('loan_charges', this.loan_charges);
      formData.append('withdraw_charges', this.withdraw_charges);

      let url = "/updatesettings";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          let userData = response.data.user;
          localStorage.setItem('user', JSON.stringify(userData));
          this.userData = userData;
          this.$toast.success("Settings Updated");
        }
      });
    },
  },
  computed: { ...countriesComputed, },
  mounted() {
    this.membership_fee = this.userData.settings.membership_fee;
    this.share_amount = this.userData.settings.share_amount;
    this.min_share = this.userData.settings.min_share;
    this.max_share = this.userData.settings.max_share;
    this.dividends = this.userData.settings.dividends;
    this.interests = this.userData.settings.interests;
    this.print_trans = this.userData.settings.print_trans;
    this.show_balance = this.userData.settings.show_balance;
    this.currency = this.userData.currency;
    this.loanlimit = this.userData.settings.loanlimit;
    this.security = this.userData.settings.security;
    this.number_of_guarantors = this.userData.settings.no_of_guarantors;
    this.combine_interest_fine = this.userData.settings.combine_interest_fine;
    this.loan_charges = this.userData.settings.loan_charges;
    this.withdraw_charges = this.userData.settings.withdraw_charges;
  },
  created() {
    this.fetchCountries();
  },
};
</script>